export const getExtension = (imageUrl) => {
    const extensionRegex = /\.(\w{3,4})(?:$|\?)/i;
    const extensionMatch = imageUrl.match(extensionRegex);
    return extensionMatch && extensionMatch[1] && extensionMatch[1].toLowerCase();
};

export const removeProtocolFromUrl = (url) => url.replace(/^(https?:|)\/\//, '//');

export const getOptimisedUrl = (imageUrl, quality = 80, width = 400, hasDescriptor) => {
    const url = removeProtocolFromUrl(`${imageUrl}/w${width}_q${quality}.${getExtension(imageUrl)}`);
    return hasDescriptor ? `${url} ${width}w` : url;
};

export const isOptimisedUrl = (imageUrl) => {
    const containsImagesphereParams = imageUrl.match(/\/w\d+(_q\d+)?\.\w+$/);
    const extensionMatches = imageUrl.match(/\.(jpg|jpeg|png|gif|webp)/gi);
    const containsDoubleExtension = extensionMatches && extensionMatches.length === 2;
    return containsImagesphereParams && containsDoubleExtension;
};

export const isImagesphereUrl = (imageUrl) => ['cache.', 'imagesphere'].some((domain) => imageUrl.includes(domain));

export const getOptimisedSrcAttrs = (imageUrl, quality = 80, defaultWidth = 400) => {
    if (!isImagesphereUrl(imageUrl) || isOptimisedUrl(imageUrl) || getExtension(imageUrl) === 'svg') {
        return {
            src: imageUrl,
        };
    }

    const widths = [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000];
    return {
        src: getOptimisedUrl(imageUrl, quality, defaultWidth),
        srcSet: widths.map((width) => getOptimisedUrl(imageUrl, quality, width, true)).join(', '),
    };
};

/**
 * Returns padding percentage that
 * yields result of passed AR
 * @param {string} ratio
 * @returns {string}
 */
export const ratioToPadding = (ratio = '') => {
    const [width, height] = ratio.split(':', 2);
    const parsedDivision = parseFloat(height) / parseFloat(width);

    if (Number.isNaN(parsedDivision)) {
        return '';
    }

    return `${parsedDivision.toFixed(4) * 100}%`;
};
